import { BOARDS_KEY_MAPPER_ENUM, TASKS_COLUMNS } from "@onesolution/constants";
import { type AppFormApi, useLanguage } from "@onesolution/hooks";
import type { TranslationsKeys } from "@onesolution/hooks/useLanguage";
import { getStatusChoicesFromServer } from "@onesolution/serverFn";

export default function TagsFilters({
	form,
}: {
	form: AppFormApi;
}) {
	const { t } = useLanguage();
	const taskStatus = getStatusChoicesFromServer.useQuery({
		boardId: BOARDS_KEY_MAPPER_ENUM.tasks,
		columnId: TASKS_COLUMNS.status,
	});
	const taskTypes = getStatusChoicesFromServer.useQuery({
		boardId: BOARDS_KEY_MAPPER_ENUM.tasks,
		columnId: TASKS_COLUMNS.type,
	});

	return (
		<div className="flex gap-2 justify-between items-center flex-wrap">
			<form.AppField name="status">
				{(field) => (
					<field.SelectMultiple
						className="w-64 grow"
						classNames={{ value: "line-clamp-1" }}
						placeholder={t("basic.status")}
						items={(taskStatus.data || []).map(
							(i: { key: string; name: string }) => ({
								name: t(`status.${i.name}` as TranslationsKeys, {
									skeleton: false,
								}),
								key: i.key,
							}),
						)}
					/>
				)}
			</form.AppField>
			<form.AppField name="type">
				{(field) => (
					<field.SelectMultiple
						className="w-64 grow"
						classNames={{ value: "line-clamp-1" }}
						placeholder={t("name.type")}
						items={taskTypes.data}
					/>
				)}
			</form.AppField>
		</div>
	);
}
